/** Thai and English text for Company: what the whole company shares. Keys follow the resource layout. */
export const th = {
  app: { name: 'Company', description: 'รายชื่อพนักงาน สาขา และข้อมูลบริษัท' },
  nav: {
    people: 'พนักงาน',
    branches: 'สาขา',
    profile: 'ข้อมูลบริษัท',
    mine: 'ของที่ฉันถือ',
    assets: 'ทรัพย์สิน',
    handovers: 'ส่งมอบ / รับคืน',
    uniforms: 'ยูนิฟอร์มและของที่แจก',
  },
  branch: {
    title: 'สาขา',
    plural: 'สาขา',
    create: 'เพิ่มสาขา',
    fields: {
      code: 'รหัสสาขา',
      name: 'ชื่อสาขา',
      type: 'ประเภท',
      phone: 'เบอร์โทร',
      address: 'ที่อยู่',
      coverage: 'พื้นที่ส่ง',
      excluded: 'พื้นที่ที่ไม่ส่ง',
      connectsTo: 'มีรถวิ่งไปสาขา',
      status: 'สถานะ',
      notes: 'หมายเหตุ',
      joinCode: 'รหัสเข้าร่วมสาขา',
      latitude: 'ละติจูด',
      longitude: 'ลองจิจูด',
      clockRadius: 'รัศมีลงเวลา (เมตร)',
    },
    options: {
      type: { counter: 'หน้าร้าน', dc: 'DC / ศูนย์กระจาย', both: 'หน้าร้านและ DC', hq: 'สำนักงานใหญ่' },
      status: { active: 'เปิด', inactive: 'ปิด' },
    },
    sections: { main: 'ข้อมูลสาขา', network: 'พื้นที่ส่งและเส้นทางรถ', clock: 'การลงเวลา' },
    clockHint: 'สแกนไกลกว่ารัศมีนี้จะถูกทำเครื่องหมายให้หัวหน้าตรวจ (ไม่ปฏิเสธ) คัดลอกพิกัดจาก Google Maps ได้',
    coverageHint: 'ใส่ทั้งจังหวัด หรือเฉพาะอำเภอ (จังหวัด/อำเภอ) สาขาที่ระบุอำเภอจะได้งานก่อน',
    coveragePlaceholder: 'พิมพ์ชื่อจังหวัดหรืออำเภอ',
    excludedHint: 'อำเภอหรือตำบลในพื้นที่ส่งที่สาขานี้ไม่ไปส่ง บิลที่จัดส่งตามที่อยู่ไปที่นั่นต้องให้ผู้รับมารับที่สาขา เว้นแต่มีสาขาอื่นส่งถึง',
    joinCodeHint: 'ติดไว้ที่สาขา คนที่ขอเปิดบัญชีต้องใส่รหัสนี้ (ขอได้เฉพาะคนที่อยู่สาขา)',
    actions: { rotateCode: 'เปลี่ยนรหัสใหม่' },
  },
  profile: {
    title: 'ข้อมูลบริษัท',
    plural: 'ข้อมูลบริษัท',
    fields: {
      name: 'ชื่อบริษัท',
      nameEn: 'ชื่อภาษาอังกฤษ',
      taxId: 'เลขประจำตัวผู้เสียภาษี',
      branch: 'สาขา',
      address: 'ที่อยู่',
      phone: 'โทรศัพท์',
      email: 'อีเมล',
      website: 'เว็บไซต์',
      signerUserId: 'ผู้มีอำนาจลงนาม',
      signerTitle: 'ตำแหน่งผู้มีอำนาจลงนาม',
    },
    hint: 'ใช้พิมพ์บนหัวเอกสาร เช่น ใบแจ้งหนี้และใบกำกับภาษี',
    signerSection: 'ลายเซ็นบนเอกสารของบริษัท',
    signerHint:
      'ลายเซ็นของผู้มีอำนาจลงนามพิมพ์บนใบแจ้งหนี้/ใบกำกับภาษีที่ออก และหนังสือรับรองการหักภาษี (50 ทวิ) คนที่เลือกต้องตั้งลายเซ็นของตัวเองไว้แล้ว และระบบแจ้งให้เขารู้',
  },
  asset: {
    title: 'ทรัพย์สิน',
    plural: 'ทรัพย์สิน',
    create: 'เพิ่มทรัพย์สิน',
    fields: {
      code: 'เลขทรัพย์สิน',
      name: 'ชื่อ',
      kind: 'ประเภท',
      serialNo: 'หมายเลขเครื่อง',
      branchId: 'ของสาขา',
      value: 'มูลค่า',
      acquiredOn: 'วันที่ได้มา',
      status: 'สถานะ',
      holderUserId: 'อยู่กับ',
      heldSince: 'ถือตั้งแต่',
      photoFileId: 'รูป',
      notes: 'หมายเหตุ',
    },
    options: {
      kind: { phone: 'มือถือ', scanner: 'เครื่องสแกน', computer: 'คอมพิวเตอร์', tool: 'เครื่องมือ / อุปกรณ์', other: 'อื่นๆ' },
      status: {
        atBranch: 'อยู่ที่สาขา',
        lending: 'รอผู้รับยืนยัน',
        withPerson: 'อยู่กับพนักงาน',
        repair: 'ส่งซ่อม',
        lost: 'สูญหาย',
        retired: 'เลิกใช้',
      },
    },
    codeHint: 'เว้นว่างได้ ระบบใส่เลขให้',
    statusHint: 'ส่งมอบและรับคืนเปลี่ยนสถานะให้เอง',
    lend: 'ส่งมอบ',
    takeBack: 'รับคืน',
  },
  assetHandover: {
    title: 'ใบส่งมอบ / รับคืนทรัพย์สิน',
    plural: 'ใบส่งมอบ / รับคืนทรัพย์สิน',
    create: 'ส่งมอบ / รับคืนทรัพย์สิน',
    fields: {
      number: 'เลขที่',
      kind: 'ประเภท',
      userId: 'พนักงาน',
      assetIds: 'ทรัพย์สิน',
      lines: 'สภาพตอนรับคืน',
      signatureFileId: 'ลายเซ็นผู้รับ',
      status: 'สถานะ',
      sentAt: 'วันที่',
      receivedAt: 'ยืนยันรับเมื่อ',
      loss: 'มูลค่าที่เสียหาย / สูญหาย',
      reviewStatus: 'ฝ่ายบัญชีตรวจ',
      reviewNote: 'หมายเหตุการตรวจ',
      reviewedBy: 'ตรวจโดย',
      reviewedAt: 'ตรวจเมื่อ',
      bondId: 'ใบเงินประกัน',
      recordedByUserId: 'บันทึกโดย',
      branchId: 'สาขา',
      notes: 'หมายเหตุ',
    },
    options: {
      kind: { lend: 'ส่งมอบ', return: 'รับคืน' },
      status: { draft: 'ร่าง', sent: 'รอผู้รับยืนยัน', received: 'รับแล้ว', returned: 'รับคืนแล้ว', cancelled: 'ยกเลิก' },
      reviewStatus: { none: 'ไม่มี', pending: 'รอฝ่ายบัญชีตรวจ', deducted: 'หักเงินประกันแล้ว', waived: 'ไม่หัก' },
      condition: { normal: 'ปกติ', damaged: 'เสียหาย', lost: 'สูญหาย' },
    },
    actions: { receive: 'ยืนยันรับของ', review: 'ตรวจของเสียหาย / สูญหาย', deduct: 'หักเงินประกัน', waive: 'ไม่หัก' },
    personHint: 'คนที่รับของ หรือคนที่คืนของ',
    lendAssetsHint: 'เฉพาะทรัพย์สินที่อยู่ที่สาขาเดียวกัน',
    returnAssetsHint: 'ทรัพย์สินที่อยู่กับพนักงานคนนี้',
    pickPersonFirst: 'เลือกพนักงานก่อน',
    signHere: 'ผู้รับไม่มีมือถือ: เซ็นรับบนจอนี้',
    signedHint: 'เซ็นรับแล้ว บันทึกแล้วถือว่ารับของทันที',
    signNote: 'ไม่เซ็น: ผู้รับต้องกดยืนยันรับในแอพ',
    certify: 'ข้าพเจ้าได้รับทรัพย์สินตามรายการครบถ้วนแล้ว',
    noteOf: 'รายละเอียด',
    deductAmount: 'จำนวนที่หัก',
    deductHint: 'มูลค่าตามทะเบียน {{amount}} บาท ไม่เกินเงินประกันที่มี',
    reviewHint: 'หักเงินประกัน: ออกใบเงินประกันแบบชดเชยความเสียหายทันที · ไม่หัก: ต้องใส่เหตุผล',
    reviewed: 'บันทึกผลตรวจแล้ว',
    received: 'ยืนยันรับแล้ว',
    confirmTitle: 'ยืนยันรับทรัพย์สิน',
    confirmBody: 'ได้รับครบแล้ว {{count}} รายการ',
  },
  uniform: {
    title: 'ยูนิฟอร์มและของที่แจก',
    plural: 'ยูนิฟอร์มและของที่แจก',
    create: 'บันทึกการแจก',
    fields: {
      userId: 'พนักงาน',
      issuedOn: 'วันที่แจก',
      item: 'ของที่แจก',
      size: 'ไซซ์',
      quantity: 'จำนวน',
      branchId: 'สาขา',
      recordedByUserId: 'บันทึกโดย',
      notes: 'หมายเหตุ',
    },
    itemHint: 'เช่น เสื้อยูนิฟอร์ม เสื้อแจ็คเก็ต รองเท้าเซฟตี้',
  },
  mine: {
    title: 'ของที่ฉันถือ',
    hint: 'ทรัพย์สินของบริษัทที่อยู่กับคุณ ต้องคืนเมื่อเลิกใช้หรือพ้นสภาพ',
    waiting: 'รอคุณยืนยันรับ',
    waitingFrom: '{{name}} ส่งมอบให้คุณ',
    holding: 'ทรัพย์สินที่ถืออยู่',
    since: 'ถือตั้งแต่ {{date}}',
    none: 'ไม่มีทรัพย์สินของบริษัทอยู่กับคุณ',
    given: 'ของที่ได้รับแจก',
    givenLine: '{{item}} {{size}} × {{quantity}}',
    countFirst: 'ตรวจของให้ครบก่อนกดยืนยัน ถ้าไม่ได้รับ อย่ากดยืนยัน แจ้งคนที่ส่งมอบ',
  },
  people: {
    title: 'พนักงาน',
    hint: 'ทุกคนในบริษัทที่ยังทำงานอยู่ เบอร์โทรแสดงเฉพาะคนที่เลือกให้แสดงไว้ที่บัญชีของฉัน',
    search: 'ค้นหาชื่อ ชื่อเล่น ตำแหน่ง หรือเบอร์',
    allBranches: 'ทุกสาขา',
    count: '{{count}} คน',
    empty: 'ไม่พบพนักงาน',
    /** A person's card */
    department: 'แผนก',
    branch: 'สาขา',
    managerLabel: 'หัวหน้างาน',
    phone: 'เบอร์โทร',
    call: 'โทร',
  },
} as const

export const en = {
  app: { name: 'Company', description: 'People, branches and company details' },
  nav: {
    people: 'People',
    branches: 'Branches',
    profile: 'Company',
    mine: 'Items I hold',
    assets: 'Assets',
    handovers: 'Handovers / returns',
    uniforms: 'Uniforms and items given',
  },
  branch: {
    title: 'Branch',
    plural: 'Branches',
    create: 'New branch',
    fields: {
      code: 'Code',
      name: 'Name',
      type: 'Type',
      phone: 'Phone',
      address: 'Address',
      coverage: 'Delivers to',
      excluded: 'Does not deliver to',
      connectsTo: 'Trucks run to',
      status: 'Status',
      notes: 'Notes',
      joinCode: 'Join code',
      latitude: 'Latitude',
      longitude: 'Longitude',
      clockRadius: 'Clock-in radius (m)',
    },
    options: {
      type: { counter: 'Counter', dc: 'DC / hub', both: 'Counter and DC', hq: 'Head office' },
      status: { active: 'Open', inactive: 'Closed' },
    },
    sections: { main: 'Branch', network: 'Delivery area and truck routes', clock: 'Time clock' },
    clockHint: 'A scan farther than this is flagged for the lead (not refused). Coordinates can be copied from Google Maps.',
    coverageHint: 'A whole province, or one district (province/district). A branch listed for the district wins.',
    coveragePlaceholder: 'Type a province or district',
    excludedHint:
      'Districts or subdistricts in its area this branch does not go to. A bill to one is collected at a branch, unless another branch delivers there.',
    joinCodeHint: 'Put it up at the branch: asking for an account needs it, so only people who are there can ask',
    actions: { rotateCode: 'New code' },
  },
  profile: {
    title: 'Company',
    plural: 'Company',
    fields: {
      name: 'Company name',
      nameEn: 'English name',
      taxId: 'Tax ID',
      branch: 'Branch',
      address: 'Address',
      phone: 'Phone',
      email: 'Email',
      website: 'Website',
      signerUserId: 'Authorized signer',
      signerTitle: 'Their title',
    },
    hint: 'Printed on document headers such as invoices and tax invoices',
    signerSection: 'Signature on company documents',
    signerHint:
      'The authorized signer’s signature is printed on the invoices issued and on tax certificates (50 ทวิ). They must have set their own signature, and are told',
  },
  asset: {
    title: 'Asset',
    plural: 'Assets',
    create: 'Add an asset',
    fields: {
      code: 'Asset no.',
      name: 'Name',
      kind: 'Kind',
      serialNo: 'Serial no.',
      branchId: 'Branch',
      value: 'Value',
      acquiredOn: 'Acquired on',
      status: 'Status',
      holderUserId: 'Held by',
      heldSince: 'Held since',
      photoFileId: 'Photo',
      notes: 'Notes',
    },
    options: {
      kind: { phone: 'Phone', scanner: 'Scanner', computer: 'Computer', tool: 'Tool / equipment', other: 'Other' },
      status: {
        atBranch: 'At the branch',
        lending: 'Waiting for the receiver',
        withPerson: 'With a person',
        repair: 'In repair',
        lost: 'Lost',
        retired: 'Retired',
      },
    },
    codeHint: 'May be left empty: the system numbers it',
    statusHint: 'Handovers and returns set the status themselves',
    lend: 'Hand over',
    takeBack: 'Take back',
  },
  assetHandover: {
    title: 'Asset handover / return',
    plural: 'Asset handovers / returns',
    create: 'Hand over / take back',
    fields: {
      number: 'No.',
      kind: 'Kind',
      userId: 'Person',
      assetIds: 'Assets',
      lines: 'Condition on return',
      signatureFileId: 'Receiver’s signature',
      status: 'Status',
      sentAt: 'Date',
      receivedAt: 'Confirmed at',
      loss: 'Value damaged / lost',
      reviewStatus: 'Accounting review',
      reviewNote: 'Review note',
      reviewedBy: 'Reviewed by',
      reviewedAt: 'Reviewed at',
      bondId: 'Security deposit slip',
      recordedByUserId: 'Recorded by',
      branchId: 'Branch',
      notes: 'Notes',
    },
    options: {
      kind: { lend: 'Hand over', return: 'Take back' },
      status: { draft: 'Draft', sent: 'Waiting for the receiver', received: 'Received', returned: 'Taken back', cancelled: 'Cancelled' },
      reviewStatus: { none: 'None', pending: 'Waiting for accounting', deducted: 'Taken from the deposit', waived: 'Not deducted' },
      condition: { normal: 'Fine', damaged: 'Damaged', lost: 'Lost' },
    },
    actions: { receive: 'Confirm received', review: 'Review damage / loss', deduct: 'Take from the deposit', waive: 'Do not deduct' },
    personHint: 'Who receives the items, or who gives them back',
    lendAssetsHint: 'Assets of one branch only',
    returnAssetsHint: 'Assets this person holds',
    pickPersonFirst: 'Choose the person first',
    signHere: 'No phone: sign for them on this screen',
    signedHint: 'Signed: received as soon as it is saved',
    signNote: 'Without a signature the receiver confirms in the app',
    certify: 'I have received every item listed',
    noteOf: 'Details',
    deductAmount: 'Amount to take',
    deductHint: 'Registered value {{amount}} THB, no more than the deposit held',
    reviewHint: 'Take from the deposit: a damage slip is recorded at once · Do not deduct: give the reason',
    reviewed: 'Review saved',
    received: 'Confirmed received',
    confirmTitle: 'Confirm received',
    confirmBody: 'You received all {{count}} items',
  },
  uniform: {
    title: 'Uniform or item given',
    plural: 'Uniforms and items given',
    create: 'Record what was given',
    fields: {
      userId: 'Person',
      issuedOn: 'Given on',
      item: 'Item',
      size: 'Size',
      quantity: 'Quantity',
      branchId: 'Branch',
      recordedByUserId: 'Recorded by',
      notes: 'Notes',
    },
    itemHint: 'e.g. uniform shirt, jacket, safety shoes',
  },
  mine: {
    title: 'Items I hold',
    hint: 'The company’s things in your hands: give them back when done or when you leave',
    waiting: 'Waiting for you to confirm',
    waitingFrom: '{{name}} handed these to you',
    holding: 'What you hold',
    since: 'Since {{date}}',
    none: 'You hold none of the company’s things',
    given: 'Given to you',
    givenLine: '{{item}} {{size}} × {{quantity}}',
    countFirst: 'Check every item before you confirm. If you did not get them, do not confirm: tell whoever handed them over',
  },
  people: {
    title: 'People',
    hint: 'Everyone still working here. A phone number shows only for those who chose to show it in My account',
    search: 'Search a name, nickname, position or phone',
    allBranches: 'All branches',
    count: '{{count}} people',
    empty: 'No one found',
    department: 'Department',
    branch: 'Branch',
    managerLabel: 'Reports to',
    phone: 'Phone',
    call: 'Call',
  },
}
